export default __webpack_public_path__ + "static/media/character_joy_body_interview.0f20e37d.svg";